import(/* webpackMode: "eager", webpackExports: ["BlogPage"] */ "/home/sksp1/apps/skillsewa.com/src/components/landing/desktop/blogs/BlogPage.tsx");
